export default {
    url: '/learnerprogress/:courseId',
    template: `
        <reports-courseresults-learner-progress
            classifiers="vm.classifiers"
            sites="vm.sites"
            course="vm.course"
            training-fields="vm.trainingFields"
        />`,
    controller (classifiers, sites, course, trainingFields) {
        this.classifiers = classifiers;
        this.sites = sites;
        this.course = course;
        this.trainingFields = trainingFields;
    },
    resolve: {
        course: (CourseResource, $stateParams) =>
                CourseResource.get({ id: $stateParams.courseId, expand: 'activeI18n' }).$promise,
        trainingFields: (ClassifierResource, CLASSIFIER_ENUM) =>
            ClassifierResource.query({
                type: CLASSIFIER_ENUM.KEYS.FIELD,
                expand: 'activeI18n',
                pageSize: 0
            }).$promise
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/courseresults/learnerprogress/index.js